export default function Bubbles(props) {
  const { index, e, size, switchBox, onClickMain, openDialog } = props;
  const { Elem, func, color } = e;
  const origin = size / 2 + 2;
  const iPos = [
    [origin - 110 - 2, -40],
    [origin - 75, -80],
    [origin + 25 - size + 2, -80],
    [origin + 60 - size + 2, -40],
  ];

  const selectFunction = () =>
    typeof func === "string" ? openDialog(func) : switchBox(e.id);

  return (
    <div
      key={index}
      className="avaSelected bubble"
      onClick={selectFunction}
      style={{
        width: size,
        height: size,
        borderRadius: origin,
        marginLeft: onClickMain ? iPos[index][0] : -origin,
        marginTop: onClickMain ? iPos[index][1] : -origin,
        opacity: onClickMain ? 1 : 0,
        filter: onClickMain
          ? "drop-shadow(3px 2px 2px rgb(70, 70, 70))"
          : "drop-shadow(0px 0px 0px rgb(0, 0, 0))",
      }}
    >
      <div style={{ marginTop: 5 }}>
        <Elem style={{ fontSize: 30, color }} />
      </div>
    </div>
  );
}
